export default __webpack_public_path__ + "1d65e211ee8eec22b82f17900da85310.png";